import React, { memo } from 'react';
import { AccordionBodyProps } from './types';
import { generateID } from '../../base/helper';

const Body = ({
  id = generateID('clientos-ui-toolkit-accordion'),
  children,
  paddingBottom = true,
  paddingEnd = true,
  paddingStart = true,
  paddingTop = true
}: AccordionBodyProps) => (
  <div
    id={`${id}-children`}
    className={`clientos-ui-toolkit-accordion__item-body${paddingStart ? ' padding-start' : ''}${paddingEnd ? ' padding-end' : ''} ${paddingTop ? ' padding-top' : ''}${paddingBottom ? ' padding-bottom' : ''}`}
  >
    {children}
  </div>
);

export default memo(Body);
